// Typelizer digest df0b0700c8484cbe13704d43341233de
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** POST /educators/teachers/:teacher_id/teams/:team_id/team_timetable/team_timetable_publications */
  create: (
    params: { teacherId: string | number; teamId: string | number },
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/educators/teachers/:teacher_id/teams/:team_id/team_timetable/team_timetable_publications', params, options),
    method: 'post',
  }),
}
